import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {CookieService} from "ngx-cookie-service";
import {StorageService} from "./storage.service";
import {handleError} from "./handle-error";
import {catchError, Observable, tap} from "rxjs";
import {AuthenticationResp} from "../model/staff";
import {AUTH_REFRESH_TOKEN_KEY} from "../../../../navigator/src/app/services/storage.service";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  basedUrl = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private cookieService: CookieService
  ) { }

  logIn(username: string, password: string): Observable<AuthenticationResp | null> {
    let headers = new HttpHeaders()
    headers = headers.set('Authorization', `Basic ${btoa(`${username}:${password}`)}`)
    return this.http.post<AuthenticationResp>(this.basedUrl + `/identity/v1/auth/staffs/signIn`, {}, {headers: headers}).pipe(
      tap(authenticationResp => authenticationResp),
      catchError(handleError<AuthenticationResp | null>("logIn", null))
    )

  }

  refreshToken(): Observable<AuthenticationResp | null> {
    let headers = new HttpHeaders()
    headers = headers.set("access_token", JSON.parse(this.cookieService.get(AUTH_REFRESH_TOKEN_KEY)).token)
    return this.http.post<AuthenticationResp>(this.basedUrl + `/identity/v1/auth/staffs/refreshToken`, {}, {headers: headers}).pipe(
      catchError(handleError<AuthenticationResp | null>("refreshToken", null))
    )
  }

  logOut(): void {
    this.storageService.clean();
    this.cookieService.deleteAll();
  }


}
